import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore, useHasHydrated } from '@/stores/authStore';
import { Loader2 } from 'lucide-react';

interface PrivateRouteProps {
  children: React.ReactNode;
}

// Loading component while hydrating
function AuthLoading() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <Loader2 className="w-8 h-8 animate-spin text-primary" />
    </div>
  );
}

export function PrivateRoute({ children }: Readonly<PrivateRouteProps>) {
  const { isAuthenticated } = useAuthStore();
  const hasHydrated = useHasHydrated();
  const location = useLocation();

  // Wait for hydration before checking auth
  if (!hasHydrated) {
    return <AuthLoading />;
  }

  // Check if authenticated
  if (!isAuthenticated) {
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  // Route-level feature/permission gating lives in CrmRouteGate (per-route `permission`).
  return <>{children}</>;
}
